import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, parse } from "date-fns";
import "./DatePickerField.css";

const DatePickerField = ({
  label,
  name,
  value,
  onChange,
  error,
  helperText,
  ...rest
}) => {
  const handleDateChange = (date) => {
    // Jeśli data jest null (użytkownik kliknął "Wyczyść"), przekaż pustą wartość
    if (!date) {
      onChange("");
      return;
    }

    // Formatowanie daty do 'yyyy-MM-dd'
    const formattedDate = format(date, "yyyy-MM-dd");

    // Wywołanie funkcji onChange z sformatowaną datą
    onChange(formattedDate);
  };

  return (
    <div className="date-picker-wrapper">
      <DatePicker
        selected={value ? parse(value, "yyyy-MM-dd", new Date()) : null}
        onChange={handleDateChange}
        dateFormat="yyyy-MM-dd"
        isClearable
        placeholderText="Wybierz datę..."
        className={error ? "date-picker-error" : ""}
        {...rest}
      />
      {error && helperText && (
        <p className="date-picker-error-text">{helperText}</p>
      )}
    </div>
  );
};

export default DatePickerField;
